import * as common from '@/store/common/mutation-types';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const CLAIM_INFO = `CLAIM_INFO`;
export const STATE_INIT = `STATE_INIT`;

export default {
	...common,
	DEFAULT_ASSIGN,
	CLAIM_INFO,
	STATE_INIT
};
